import { ActiveMember, MemberKind } from '../types/members-types';

export const reduceRelatedMembersIDs = (activeMembers: ActiveMember[]) => {
  return Object.values(
    activeMembers.reduce(
      (acc: Record<string, ActiveMember>, cur: ActiveMember) => {
        const am: ActiveMember = { ...cur };
        am.relatedIDs = [];
        const found = acc[am.email];
        if (found) {
          found.relatedIDs = [...found.relatedIDs, am.user_id];
        } else {
          acc[am.email] = { ...am, kind: MemberKind.ActiveMember };
        }
        return acc;
      },
      {},
    ),
  );
};
